import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { BookOpenText, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaOrientacaoCompletaCriada = (acao: string): boolean => {
    const texto = (acao || "").toLowerCase();

    return texto.includes("orientações completas criadas") || (texto.includes("criou orientacao") && !texto.includes("previa"));
};

const getIconOrientacaoCompleta = (_acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: BookOpenText, color: "var(--c8e44ad)" };
};

export default function CardOrientacaoCompletaCriada({
    item,
    onNavigateToFile,
    isExpanded,
    onToggleExpand
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconOrientacaoCompleta(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const orientacaoCompletaCriadaConfig = {
    tipo: "orientacao_completa_criada",
    detectaTipo: detectaOrientacaoCompletaCriada,
    getIcon: getIconOrientacaoCompleta,
    temExpansao: () => true,
    Component: CardOrientacaoCompletaCriada
};

